module.exports = __webpack_public_path__ + "img/UsingData_2.0cf01429.png";